// extracted by mini-css-extract-plugin
export var cookiesContainer = "cookiesWarning-module--cookiesContainer--KR6cN";
export var cookiesText = "cookiesWarning-module--cookiesText--vY+lD";